export default __webpack_public_path__ + "static/media/ekosistemgambar.bdafd515.jpg";